
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cennik-mvp",
      function () {
        return require("private-next-pages/cennik-mvp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cennik-mvp"])
      });
    }
  